module.exports = __webpack_public_path__ + "static/media/left-down.00990d3f.svg";